export function resolveMode(theme) {
  if (theme !== 'system') return theme
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function applyTheme(theme, colorSet) {
  const mode = resolveMode(theme)
  const key = `${mode}-${colorSet}`
  if (key === 'dark-modern') {
    document.documentElement.removeAttribute('data-theme')
  } else {
    document.documentElement.setAttribute('data-theme', key)
  }
}

export function loadThemePrefs() {
  return {
    theme:    localStorage.getItem('gunsi_theme')    ?? 'system',
    colorSet: localStorage.getItem('gunsi_colorset') ?? 'classic',
  }
}

export function saveThemePrefs(theme, colorSet) {
  localStorage.setItem('gunsi_theme', theme)
  localStorage.setItem('gunsi_colorset', colorSet)
}
